const treatmentPlanTool = {
  accessDispensary: "Entire dispensary",
  accessDispensaryDescription:
    "All current and future {{patientsTerm}} in this dispensary will have access. If other practitioners use this dispensary, their {{patientsTerm}} will also have access.",
  newAccessDispensaryDescription:
    "All current and future {{patientsTerm}} in this dispensary will have access, including minor {{patientsTerm}} managed by parents. If other practitioners use this dispensary, their {{patientsTerm}} will also have access.",
  accessDispensaryTooltipSelected:
    "Your account access is limited to only your patients. Patients within the entire dispensary will have access to this plan until you update the access below.",
  accessDispensaryTooltipNotSelected: "Your account access is limited to only your patients.",
  accessMine: "All my {{patientsTerm}}",
  accessMineDescription:
    "All current and future {{patientsTerm}} who are assigned to you will have access.",
  newAccessMineDescription:
    "All current and future {{patientsTerm}} who are assigned to you will have access, including minor {{patientsTerm}} managed by their parents.",
  accessSpecificPatients: "Specific {{ patientsTerm }}",
  accessSpecificEmptyDescription: "Only you can access this plan.",
  accessSearchForPatients: "Search for {{ patientsTerm }} to share with...",
  accessSearchForStafff: "Search for staff...",
  accessMyStaff: "All staff",
  amountAccessStaff: "{{amount}} staff",
  accessMyStaffDescription:
    "All practitioners and staff in your dispensary can access this template.",
  accessSpecificStaff: "Specific staff",
  accessSendEmail: "Send an email notification to my {{ patientsTerm }}.",
  sendEmailLabel: "Email {{ patientsTerm }} with access to plan",
  accessSendEmailDescription:
    "Only {{ patientsTerm }} with new access to this plan will be notified.",
  accessMultiPatientTooltip:
    "{{ patientsTermCapitalized }} created in the future will be able to view this plan.",
  accessSpecificMultiPatientTooltip:
    "We'll email {{patientsTerm}} that have been added to this plan.",
  accessSpecificTemplateTooltip: "Selected staff will be able to view this plan.",
  accessAllStaffTemplateTooltip: "Staff created in the future will be able to view this plan.",
  accessOnlyYouCTA: "only you",
  accessAllStaffCTA: "all staff",
  accessStaffCTA: "selected staff",
  accessSelectedCTA: "selected {{ patientsTerm }}",
  accessMineCTA: "all of your {{ patientsTerm }}",
  accessAllCTA: "the entire dispensary",
  accessOnlyMe: "Only me",
  planFor: "Plan for",
  individualPlanType: "This is an individual plan.",
  templatePlanType: "This is a template.",
  multiPatientPlanType: "This is a multi-{{patientTerm}} plan.",
  planType: "Plan type",
  planName: "Plan name",
  templateName: "Template name",
  individual: "Individual",
  multiPatient: "Multi-{{patientTerm}}",
  template: "Template",
  lastUpdated: "Draft last updated on",
  resetDraftButton: "Reset draft",
  at: "at",
  or: "or",
  searchPlaceholder: "Search to add {{patientTerm}}...",
  patientNotFound: "{{patientTerm}} not found",
  selectPatient: "Select {{patientTerm}}",
  warningPriceText: "{{patientTermCapitalized}} discounts apply on a per-{{patientTerm}} basis.",
  access: "Access",
  templateFor: "Template for",
  removePatient: "Remove {{patientTerm}}",
  removePatientTooltip: "You can't change the assigned {{patientTerm}} on a sent individual plan.",
  removePatientSelectionTooltip:
    "{{patientTermCapitalized}}  selection can't be modified in a published plan.",
  viewHistory: "View history",
  copyLink: "Copy link",
  noResults: "Results not found",
  individualPlanCTADraft: "Send to {{patientTerm}}",
  planCTAUpdate: "Update plan",
  multiPatientPlanCTA: "Publish plan",
  multiPatientPlanUpdateCTA: "Update plan",
  multiPatientPlanTooltip: "Add at least one product and choose a plan name to publish this plan.",
  templateCTA: "Save template",
  templatePlanTooltop: "Add at least one product and choose a template name to save this template.",
  templatePlanSaveSuccessToast: "Template saved",
  successAccessUpdate: "Updated share access.",
  individualCTAInfoWithText: "We will send an email and a text message to {{- patient }}.",
  individualCTAInfoWithoutText: "We will send an email to {{- patient }}.",
  publishedIndividualCTAInfoWithText:
    "We will send an email and a text message to {{- patient }} once the plan is updated.",
  publishedIndividualCTAInfoWithoutText:
    "We will send an email to {{- patient }} once the plan is updated.",
  multiCTAInfo: "Plans will be published to your catalog and {{ patientGroup }} will have access.",
  newMultiCTAInfo:
    "Plans will be published to your catalog and {{ patientGroup }} will have access, including minor {{ patientsTerm }} managed by their parents.",
  templateCTAInfo:
    "Template will be saved to your templates and {{ staffGroup }} will have access.",
  templateReviewMessage:
    "This will be saved to your templates and {{ staffGroup }} will have access.",
  copyPlanNotes: "Copy plan notes",
  PlanSuccessBanner: {
    title: "Plan sent successfully",
    content: "{{- patient }} can access this plan by logging in to their account.",
  },
  personalizedByYou: "Personalized by You",
  AM: "AM",
  PM: "PM",
  resetDraft: {
    plan: "Draft plan reset successfully!",
    template: "Draft template reset successfully!",
    yesReset: "Yes, reset my draft",
    confirmationTitle: "Reset draft plan",
    confirmationTextIndividual:
      "Are you sure you want to reset this draft? All the contents of your plan will be removed except for the plan type and the {{patientTerm}} information.",
    confirmationTextMultiPatient:
      "Are you sure you want to reset this draft? All the contents of your plan will be removed except for the plan type.",
    confirmationTextTemplate:
      "Are you sure you want to reset this draft? All the contents of your plan will be removed except for the plan type and access settings.",
  },
  replaceDraftModal: {
    title: "Existing draft found",
    message:
      "A draft already exists for {{ patientName }}. Do you want to replace your current plan with the existing draft?",
    keepButton: "No, keep my current plan",
    replaceButton: "Yes, replace",
    success: "Draft loaded successfully",
  },
  viewPatientDetails: "View {{ patientTerm }} details",
  notifiedByEmail: "{{patientFullName}} will be notified by email.",
  linkedPatient: "Linked to <strong>{{externalApplicationName}}</strong>",
  linkedPatientNotification:
    "This {{patientTerm}} is linked to <strong>{{externalApplicationName}}</strong>. This plan will be reflected in their EHR profile.",
  changeLinkButton: "Change link",
  relinkModalTitle: "Change linked {{patientTerm}}",
  relinkModalSentBack: "You will be sent back to the {{patientTerm}} linking page",
  relinkModalSeverLink:
    "By clicking continue, you are severing this {{patientTerm}} link and will be forced to select a new {{patientTerm}}.",
} as const;

export { treatmentPlanTool };
